import { useCopyChat } from '@modules/oracle/hooks';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { getWisdomRoute } from '@modules/oracle/utils';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';

export function CreateCopyChatButton() {
  const chatID = useOracleSearchStore(({ data }) => data.chat?.id);
  const [copyChat, { isLoading }] = useCopyChat();
  const navigate = useNavigate();

  if (!chatID) {
    return null;
  }

  const onClick = async () => {
    const resp = await copyChat(chatID);
    const newChat = resp.data?.copyChat?.chat;

    if (newChat?.id) {
      navigate(
        getWisdomRoute({
          name: newChat.title,
          token: newChat.viewToken,
        }),
      );
    }
  };

  return (
    <LoadingButton
      variant="contained"
      color="primary"
      loading={isLoading}
      onClick={onClick}
    >
      Create a copy to Ask follow-up
    </LoadingButton>
  );
}
